export enum PanelViewMode {
    List = 1,
    Detail = 2,
    New = 3
}

export enum DetailPanelView {
    Detail = 'detail',
    Edit = 'edit',
    AttachFiles = 'attachFiles'
}

export enum CreatePanelView {
    Create = 'create',
    AttachFiles = 'attachFiles'
}
